import React from "react";
import { ExtendedWarrantyCard } from "./ExtendedWarrantyScreenWrapper";
import { CheckCircle } from "lucide-react";

const ExtendedWarrantyReadOnlySummary = ({
  sortedQuestions,
  answers,
  previousResponses,
  onContinue,
}) => {
  if (!sortedQuestions.length || !answers) return null;

  // Filter only CHOICE type questions that have answers
  const answeredChoiceQuestions = sortedQuestions.filter(
    (question) => question.type === "CHOICE" && answers[question.id]
  );

  const getDisplayValue = (question, answer) => {
    if (answer.multiSelect && answer.values) {
      // Multi-select: show all selected options
      const selectedTexts = answer.values.map((value) => {
        const option = question.options?.find((opt) => opt.value === value);
        return option ? option.text : value;
      });
      return selectedTexts.join(", ");
    } else if (answer.value) {
      // Single-select: show the selected option text
      const option = question.options?.find((opt) => opt.value === answer.value);
      return option ? option.text : answer.value;
    }
    return "";
  };

  return (
    <ExtendedWarrantyCard>
      <div className="space-y-6">
        {/* Header */}
        <div className="text-center">
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <CheckCircle className="w-8 h-8 text-green-600" />
          </div>
          <h2 className="text-xl font-bold text-gray-900">
            Your Survey Responses
          </h2>
          <p className="text-sm text-gray-600 mt-2">
            Review your previous answers below
          </p>
        </div>

        {/* Answers Summary */}
        <div className="space-y-4">
          {answeredChoiceQuestions.map((question, index) => {
            const answer = answers[question.id];
            const displayValue = getDisplayValue(question, answer);

            return (
              <div
                key={question.id}
                className="border-b border-gray-100 pb-4 last:border-b-0"
              >
                <div className="flex items-start gap-3">
                  <span className="bg-purple-100 text-purple-800 text-xs font-medium px-2.5 py-0.5 rounded-full flex-shrink-0 mt-1">
                    {index + 1}
                  </span>
                  <div className="flex-1">
                    <h4 className="font-medium text-gray-900 text-sm mb-1">
                      {question.prompt}
                    </h4>
                    <p className="text-gray-700 text-sm">{displayValue}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Continue Button */}
        <button
          onClick={onContinue}
          className="w-full flex uppercase font-bold items-center justify-center gap-2 bg-purpleGradient text-white px-4 py-3 rounded-lg hover:bg-purpleGradientDark transition-colors"
        >
          Continue to Vehicle Options
        </button>
      </div>
    </ExtendedWarrantyCard>
  );
};

export default ExtendedWarrantyReadOnlySummary;